/**
 * Site Template Index
 *
 * Exports all industry templates so the frontend can:
 * 1. Offer downloadable templates during tenant creation
 * 2. Auto-populate site content based on selected industry
 * 3. Merge uploaded custom JSON with defaults
 */

import hospitalContent from './hospital.site-content.json';
import hospitalBranding from './hospital.branding-guide.json';
import restaurantContent from './restaurant.site-content.json';
import restaurantBranding from './restaurant.branding-guide.json';
import salonContent from './salon.site-content.json';
import salonBranding from './salon.branding-guide.json';
import defaultContent from './default.site-content.json';
import defaultBranding from './default.branding-guide.json';

export const TEMPLATES = {
  hospital: { content: hospitalContent, branding: hospitalBranding },
  restaurant: { content: restaurantContent, branding: restaurantBranding },
  salon: { content: salonContent, branding: salonBranding },
  default: { content: defaultContent, branding: defaultBranding },
};

// Map industry category names/codes to template keys
const INDUSTRY_MAP = {
  hospital: 'hospital',
  clinic: 'hospital',
  healthcare: 'hospital',
  medical: 'hospital',
  homeo: 'hospital',
  pharma: 'hospital',
  restaurant: 'restaurant',
  cafe: 'restaurant',
  food: 'restaurant',
  catering: 'restaurant',
  salon: 'salon',
  spa: 'salon',
  beauty: 'salon',
  wellness: 'salon',
};

/**
 * Get the template key for a given industry name/code
 */
export function getTemplateKey(industryName) {
  if (!industryName) return 'default';
  const lower = industryName.toLowerCase();
  for (const [keyword, key] of Object.entries(INDUSTRY_MAP)) {
    if (lower.includes(keyword)) return key;
  }
  return 'default';
}

/**
 * Get templates for a given industry
 */
export function getTemplatesForIndustry(industryName) {
  const key = getTemplateKey(industryName);
  return TEMPLATES[key] || TEMPLATES.default;
}

/**
 * Download a template as a JSON file
 */
export function downloadTemplate(templateData, filename) {
  const blob = new Blob([JSON.stringify(templateData, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
